export default {
    labels: {
        title: 'Detalhes da conta',
        generalInformation: 'Informações gerais',
        chargesList: 'Lista de cobranças',
        reinvoicedAccounts: 'Contas faturadas novamente',
        accountSupports: 'Documentos da contas',
        supportsAdministrator: 'Administrador de documentos',
        pendingAccountSupportFiles: 'Documentos da conta ausentes',
        receivedAccountSupportFiles: 'Documentos da conta recebidos',
        pendingProductConfiguration: 'Produtos não configurados. Verifique os marcados em vermelho na lista de cobranças.',
        agreements: 'Configuração de convênio',
        baseAccount: 'Conta origem',
        generateAccountTitle: 'Você quer gerar a conta incompleta?',
        generateAccountSubtitle: 'Esta conta tem ({count}) documentos ausentes. Tem certeza de que deseja continuar? Esta ação não pode ser revertida ou interrompida.',
        generateAccountButton: 'Gerar conta',
        reGenerateAccountButton: 'Regerar conta',
        statusTooltip: {
            label: 'Última atualização em {date} às {time} por {username}.',
            updatedBy: 'processo automatizado'
        }
    },
    statuses: {
        PENDING: 'Pendente',
        READY_TO_GENERATE: 'Pronto para gerar',
        GENERATED: 'Gerado',
        VOIDED: 'Desabilitado',
    },
    charges: {
        search: 'Pesquisar por ID de posição',
        serviceType: 'Tipo de atendimento',
        from: 'De',
        to: 'Até',
        notRequire: 'Não requer',
        invoiceableFalse: 'Não faturável',
        completed: 'Completa',
        notCompleted: 'Incompleta',
        serviceTypes: {
            hospitalization: 'Internação',
            urgency: 'Pronto Socorro',
            outpatientCare: 'Consulta externa',
            procedure: 'Procedimento',
            exam: 'Exame',
        },
        grid: {
            chargeId: 'ID de cobrança',
            eventNumber: 'Atendimento',
            eventDate: 'Data do atendimento',
            invoiceAssigned: 'Faturado',
            eventId: 'Atendimento',
            serviceType: 'Tipo de atendimento',
            providerProductCode: 'Código do item',
            patientName: 'Nome do paciente',
            chargeDescription: 'Descrição',
            creationDateTime: 'Data de criação',
            hasDocumentationComplete: 'Doc.',
            totalAmount: 'Valor ({currency})',
            hasAuditorComments: 'Comentários',
            executorService: 'Especialidade',
        }
    },
    finalizedAuditProcess: {
        completeAudit: 'Auditoria completa',
        uploadReconciliationRecord: 'Carregar relatório de auditoria',
        noAttachedFiles: 'Sem documentos anexos',
        uploadRestrictions: 'Arquivos em formato PDF, PNG ou JPEG, tamanho máximo 20Mb',
        withoutFileUploads: 'Continuar sem documentação'
    }
}
